import firebase from "datastore/database";
import store from "datastore/store";

export default function observeGroupPermissions(groupBuid) {
  if (!groupBuid) return;
  store.dispatch({ type: "ADD_GROUP_PERMISSIONS_LOADING" });

  return firebase
    .firestore()
    .collection(`access-controls/business-groups/${groupBuid}`)
    .onSnapshot(
      (snapshot) => {
        const permissions = {};

        snapshot.forEach((doc) => {
          permissions[doc.id] = doc.data();
        });

        store.dispatch({
          type: "ADD_GROUP_PERMISSIONS_SUCCESS",
          groupPermissions: permissions,
        });
      },
      (error) => {
        store.dispatch({ type: "ADD_GROUP_PERMISSIONS_ERROR", error });
      }
    );
}
